import { render, staticRenderFns } from "./SidebarLinks.vue?vue&type=template&id=fc17bd5c&scoped=true&"
import script from "./SidebarLinks.vue?vue&type=script&lang=js&"
export * from "./SidebarLinks.vue?vue&type=script&lang=js&"
import style0 from "./SidebarLinks.vue?vue&type=style&index=0&id=fc17bd5c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc17bd5c",
  null
  
)

export default component.exports